import CircularProgress from "./CircularProgress.svelte";

document.querySelectorAll(".tim-review__overall").forEach(element => {
  const progress = element.getAttribute("data-overall-rating");
  const maxRating = element.getAttribute("data-max-rating");
  new CircularProgress({
    target: element,
    props: {
      progress,
      maxRating,
      radius: 120,
      stroke: 20
    }
  });
});

// const app = ;

// export default app;
